import { SurveyAnswerType, TemplateType } from 'models/item';
import toTitleCase from 'utils/toTitleCase';

export const formatItemTemplate = (template: TemplateType, answerType?: SurveyAnswerType): string => {
  if (!template) return 'None';
  switch (template) {
    case 'question_and_answers':
      return 'Question and Answer';
    case 'vocabulary':
      return 'Vocabulary';
    case 'sequences':
      return 'Sequence';
    case 'regions':
      return 'Diagram';
    case 'instructional_contents':
      return 'Instructional Content';
    case 'associations':
      return 'Flashcard';
    case 'free_responses':
      return 'Free Response';
    case 'passages':
      return 'Passage';
    case 'ratings':
      return 'Ratings';
    case 'survey_question_and_answers':
      if (!answerType) return 'Question and Answer';
      return answerType === 'multi_correct' ? 'Multiple Select Question' : 'Single Select Question';
    default:
      return toTitleCase((template as string).replace(/_/g, ' '));
  }
};
